import { INeoAction } from './../Actions.interface';
import { isActionValid } from '../../Helpers/Reducer.helper';
import { REQUEST_ACTIONS, STATUS, BOOKING_LIST_ACTIONS } from '../../Constants/Actions.constants';
import { IBookingSimple, IPresenceUpdate, IBookingUpdate } from '../../Models/DTO/Booking.models';

const useValidAction = isActionValid([
  REQUEST_ACTIONS.BOOKING_LIST,
  REQUEST_ACTIONS.BOOKING_PRESENCE_UPDATE,
  REQUEST_ACTIONS.BOOKING_UPDATE,
  REQUEST_ACTIONS.BOOKING_UPDATE_SINGLE,
  BOOKING_LIST_ACTIONS.CLEAR,
  REQUEST_ACTIONS.BOOKING_UPDATE_PRESENCE_MULTIPLE,
]);

export default (state: IBookingSimple[] = [], action: INeoAction): IBookingSimple[] => {
  const { name, status, payload } = action;
  const actionValid = useValidAction(name);
  if (!actionValid) return state;

  if (name === BOOKING_LIST_ACTIONS.CLEAR) return [];

  if (status === STATUS.SUCCESS) {
    switch (name) {
      case REQUEST_ACTIONS.BOOKING_LIST: {
        // TODO: Take into account pagination later
        return payload;
      }
      case REQUEST_ACTIONS.BOOKING_PRESENCE_UPDATE: {
        const mutableState = [...state];
        const indexOfUpdatedBooking = mutableState.findIndex(
          (booking) => booking.id === payload.bookingId,
        );

        mutableState[indexOfUpdatedBooking] = {
          ...mutableState[indexOfUpdatedBooking],
          presenceType: payload.presenceType,
        };

        return mutableState;
      }
      case REQUEST_ACTIONS.BOOKING_UPDATE_PRESENCE_MULTIPLE: {
        return state.map((booking) => {
          const update = payload.find((data: IPresenceUpdate) => booking.id === data.bookingId);
          if (update) {
            return {
              ...booking,
              ...update,
              id: update.bookingId,
            };
          }
          return booking;
        });
      }
      case REQUEST_ACTIONS.BOOKING_UPDATE: {
        return state.map((booking) => {
          const update = payload.find((data: IBookingUpdate) => booking.id === data.bookingId);
          if (update) {
            return {
              ...booking,
              id: update.bookingId,
              status: update.bookingStatus,
            };
          }
          return booking;
        });
      }
      case REQUEST_ACTIONS.BOOKING_UPDATE_SINGLE: {
        return state.map((booking) => {
          if (payload.bookingId === booking.id) {
            return {
              ...booking,
              id: payload.bookingId,
              status: payload.bookingStatus,
            };
          }
          return booking;
        });
      }
      default:
        return state;
    }
  }
  return state;
};
